const AdManagement = () => import(/*wechat-mini*/'@/page/member/wechatMini/adManagement.vue')

const RouteTemp = () => import('@/page/commons/routeTemp.vue')
export const wechatMini=
    {
        path: '/main/wechatmini',
        name: '小程序管理',
        component: RouteTemp,
        meta: {
            requireAuth: true,
        },
        children: [{
            path: '/main/wechatmini/admanagement',
            name: '广告管理',
            component: AdManagement,
            meta: {
                requireAuth: true,
            },
        },
        
        ]
    
}